































import Vue from "vue";
// import { Carousel, Slide } from "vue-carousel";
import Follow from "./Follow.vue";
import goToSpace from "@/utils/goToSpace";

export default Vue.extend({
  props: ["config"],
  methods: {
    goToSpace
  },
  components: {
    // Carousel,
    // Slide,
    Follow
  }
});
